/* global $:false */

import $ from 'jquery';
import 'select2';
import 'slick-carousel';
import * as MarkerClusterer from '@google/markerclusterer';
import iframeResize from 'iframe-resizer/js/iframeResizer';
import objectFitImages from 'object-fit-images';

import './nav';
import './search-dropdown';
import {VK_ESC, VK_SPACE, VK_END, VK_ENTER, VK_HOME, VK_LEFT, VK_UP, VK_RIGHT, VK_DOWN} from './lib/keycodes';

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import MultiForm from './components/MultiForm.vue';
import EventOccurrences from './components/EventOccurrences.vue';
import FilterableTable from './components/FilterableTable.vue';

/* Init our Vue Multiform only if it exists on the page */

(el => {
  if (el) {
      Vue.use(VeeValidate);

      new Vue({
          el: '#trustCommerceEventRegistration',
          name: 'Trust Commerce Event Registration Form',
          components: {
              'MultiForm': MultiForm
          },
          template: '<MultiForm/>'
      });
  }
})(document.getElementById('trustCommerceEventRegistration'));

(el => {
  if (el) {
      new Vue({
          el: '#event-occurrences',
          name: 'Load More Event Occurrences',
          components: {
              'EventOccurrences': EventOccurrences
          },
          template: '<EventOccurrences />'
      });
  }
})(document.getElementById('event-occurrences'));

(els => {
    if (els) {
        Array.from(els).forEach( el => {
            let namespace = el.dataset.namespace;

            new Vue({
                el: el,
                name: 'Filterable Table',
                components: {
                    'FilterableTable': FilterableTable
                },
                template: `<FilterableTable namespace="${namespace}" />`
            });
        });
    }
  })(document.querySelectorAll('[data-component="filterable-table"]'));

// Removes queryparams, hashbang, and trailing slash from a url
function cleanUrl(url) {
    return url.split('?')[0].split('#')[0].replace(/\/$/, '');
}

// Some state to keep track of some events happening
let documentReady = false;
let mapLoaded = false;

// This callback is explicitly set to run when the Google Maps API loads
// and when the document is ready. Once both have happened we emit a
// gmapsLoaded event and run a global initMap function if it exists
// (There are some maps that depend on that function);
function fireMapsEvent() {
    if(!documentReady || !mapLoaded) return;

    let gmapsLoaded = null;

    if(typeof(Event) === 'function') {
      gmapsLoaded = new Event('gmapsLoaded');
    } else {
        gmapsLoaded = document.createEvent('Event');
        gmapsLoaded.initEvent('gmapsLoaded', true, true);
    }

    window.dispatchEvent(gmapsLoaded);

    if(typeof window.initMap === 'function') {
        window.initMap();
    }
}

// Explicit callback that google maps will run once it's loaded
window.googleMapsLoaded = () => {
    mapLoaded = true;
    fireMapsEvent();
};

$(function() {
    $.fn.clickToggle = function(func1, func2) {
        const funcs = [func1, func2];

        this.data('toggleclicked', 0);
        this.click(function() {
            var data = $(this).data();
            var tc = data.toggleclicked;
            $.proxy(funcs[tc], this)();
            data.toggleclicked = (tc + 1) % 2;
        });
        return this;
    };

    $.fn.toggleBoolAttr = function(attrName) {
        const currentVal = this.attr(attrName);
        if (currentVal === 'true') {
            this.attr(attrName, 'false');
        } else {
            this.attr(attrName, 'true');
        }
    };

    var old_ie = !!$('.lt-ie9').length;

    // Placeholder polyfill
    if (old_ie) {
        $('input, textarea').placeholder(); // fix placeholders in old ie
    }

    var $objectImages = $('img.js-object-fit');
    objectFitImages($objectImages);

    // open all external links in new tab
    $('a[href^="http://"], a[href^="https://"]').each(function(i, el) {
        const $el = $(el);
        if (!el.href.startsWith(window.location.origin)) {
            $el.attr('target', '_blank');
            $el.attr('rel', 'noopener');
        }
    });

    $('.has-code-tag').click(function(e) {
        var code_tag = this.dataset.codetag;
        $(this).after(code_tag);
        $(".has-code-tag").siblings("img").error(function () {
            $(this).hide();
        });
    });

    // ////////////////////////////////////// START MODAL

    // Modal window
    const $mobileBtns = $('.mobile-btns');
    $('.modal-btn').click(function(e) {
        e.preventDefault();

        if ($(this).attr('data-media')) {
            var mediaSlug = $(this).attr('data-media');
            jQuery.each( pagemedia, function( slug, val ) {
                if (slug == mediaSlug) {
                    $('.modal-overlay').html(val);
                }
            });
            $('body').toggleClass('modal-body');
            $('.modal-overlay').fadeToggle(250);
            $('.modal-overlay').addClass('contains-media');
        } else {
            $('body').toggleClass('modal-body');
            $('.modal-overlay').fadeToggle(250);
        }
    });

    $('.modal-overlay').click(function(e) {
        var $self = $(this);

        // Log an interaction with the pop up.
        if ($self.hasClass('pop-up')) {
            $.ajax({
                url: '/pop-up-cookie/' + $self.attr('data-pop-up-id') + '/',
            });
        }

        // Close the modal if the overlay part is clicked.
        if (e.target == this) {
            $('body').toggleClass('modal-body');
            if ($self.hasClass('menu')) {
                $mobileBtns.attr('aria-expanded', 'false');
            } else {
                if ($self.hasClass('access-modal-overlay')) {
                    $self.removeClass('pop-up').removeClass('modal-close')
                } else {
                    $self.fadeToggle(250);
                }
            }

            if ($self.hasClass('contains-media')) {
                $self.html('');
                $('.modal-overlay').removeClass('contains-media');
            }
        }
    });

    $('.modal-overlay .modal-close').click(function(e) {
        // Check that clicked element has a url to check
        if(this.href) {
            // Strip urls of unimportant information
            var currentUrl = cleanUrl(window.location.href);
            var destinationUrl = cleanUrl(this.href);
            if(currentUrl === destinationUrl) {
                // If urls are the same, prevent browser from navigating away
                e.preventDefault();
            }
        }

        const $overlay = $(this).closest('.modal-overlay');
        $('body').removeClass('modal-body');
        if ($overlay.hasClass('access-modal-overlay')) {
            $overlay.removeClass('pop-up').removeClass('modal-close')
        } else {
            $overlay.fadeToggle(250);
            $overlay.addClass('closed');
        }

        // Focus correct element when modal is closed
        var focusedMain = false;
        $(window).on('keyup', function(e) {
            if (focusedMain) return;
            if (e.keyCode != 9) return;
            $('#skip-to-content').focus();
            focusedMain = true;
        });
    });

    // Modal accessibility
    if($('.modal-overlay.pop-up').length > 0) {
        var modalFocusable = $('.modal-overlay.pop-up a');
        var current = 0;
        $(window).on('keyup', function(e) {
            if (e.keyCode != 9) return;
            if($('.modal-overlay.pop-up').hasClass('closed')) return;
            if (current == modalFocusable.length) current = 0;
            modalFocusable[current].focus()
            current++
        });
    }

    // ////////////////////////////////////// END MODAL

    // ////////////////////////////////////// START ACCESS PAGE MODAL

    $('.access-expand-pop-up-trigger').click(function(e) {
        $('body').addClass('modal-body');
        var triggerId = $(this).data('pop-up-trigger-id');
        var targetPopup = $('.modal-overlay[data-pop-up-id=' + triggerId + ']').first();
        targetPopup.addClass('pop-up').addClass('modal-close')
    });

    // ////////////////////////////////////// END ACCESS PAGE MODAL

    // ////////////////////////////////////// START PHYSICIAN FILTER MODAL

    // VARIOUS HELPER FUNCTIONS
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        // Determine of param will be the first param in the uri
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        // Test if key in uri
        if (uri.match(re)) {
            // Replace values inbetween the two sets of params "()"" in regex expression
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }

    function getUriParam(key) {
        key = key.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
        var regexS = "[\\?&]"+key+"=([^&#]*)";
        var regex = new RegExp( regexS );
        var results = regex.exec( window.location.href );
        if ( results == null ) return "";
        else return results[1];
    }

    var delay = (function(){
      var timer = 0;
      return function(callback, delaytime){
        clearTimeout (timer);
        timer = setTimeout(callback, delaytime);
      };
    })();

    var physicianResultsHandlers = function() {
        // Modal window
        $('.js-physician-filters button').click(function(e) {
            $('body').addClass('noscroll');
            $('.physicians-filters-modal').fadeIn(250);
        });

        $('.physicians-filters-modal #close-modal').click(function(e) {
            $('body').removeClass('noscroll');
            $('.physicians-filters-modal').fadeOut(250);
        });
    };

    physicianResultsHandlers();

    var physicianFilters = function() {

        $('.physicians-searchbar input[name="physquery"]').on('keyup', function(e) {
            var code = (e.keyCode || e.which);
            var ignore_codes = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93]
            if (ignore_codes.indexOf(code) >= 0) {
                return;
            }
            var $input = $(this);
            delay(function(){
              applyPhysicianSearchQuery(e, $input);
            }, 400 );
        });

        $('.physicians-searchbar').submit( function(e) {
            e.preventDefault();
            var $input = $(this).find('input');
            applyPhysicianSearchQuery(e, $input)
        });

        $('.module-physicians-listing-filters form').submit(function(e) {
            e.preventDefault();
            var loader = $('.physicians-results-loader .module-loader');
            var physicianForm = $(this);
            var listing_results = $('.page-content #results');
            listing_results.css({'opacity': '0.3', 'pointer-events': 'none'});
            loader.show();
            var sort_value = getUriParam('sort');
            var phys_query = getUriParam('physquery');
            var get_uri = window.location.pathname + '?listing=1&' + physicianForm.serialize();
            if (sort_value) {
                get_uri += '&sort=' + sort_value
            }
            if (phys_query) {
                get_uri += '&physquery=' + phys_query
            }
            var get_data = $.get(get_uri);
            get_data.done(function(data) {
                listing_results.css({'opacity': '1', 'pointer-events': 'auto'}).html($($.parseHTML( data )).find(".page-content #results").html());
                loader.hide();
                window.history.pushState("", "", get_uri);
                // // recall js functions after ajax post to reinitialize
                physicianResultsHandlers(e);
                initializeSelectSingle(e);
                backToTop(e);
                listingMoreCheck(e);
            });

        });

        $('.physicians-filters-modal form').submit(function(e) {
            e.preventDefault();
            var physicianForm = $(this);
            var sort_value = getUriParam('sort');
            var phys_query = getUriParam('physquery');
            var get_uri = window.location.pathname + '?listing=1&' + physicianForm.serialize();
            if (sort_value) {
                get_uri += '&sort=' + sort_value
            }
            if (phys_query) {
                get_uri += '&physquery=' + phys_query
            }
            window.location.href = get_uri;
        });

        $('.module-physicians-listing-filters .select2-filters').on('change', function() {
            // submit nearest form
            $(this).closest('form').submit();
        });

        $('.module-physicians-listing-filters input[type="text"]').on('keyup', function(e) {
            // submit nearest form
            var code = (e.keyCode || e.which);
            var ignore_codes = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93]
            if (ignore_codes.indexOf(code) >= 0) {
                return;
            }
            const $form = $(this).closest('form');
            delay(function(){
              $form.submit();
            }, 400 );
        });

        $('.module-physicians-listing-filters input[type="checkbox"]').on('click', function() {
            // submit nearest form
            $(this).closest('form').submit();
        });
    };

    physicianFilters();

    function applyPhysicianSearchQuery(e, input) {
        const updated_uri = updateQueryStringParameter(window.location.href, 'physquery', input.val());
        if (input.hasClass('no-listing')) {
            var loader = $('.physicians-page-content-loader .module-loader');
            loader.show();
            var searchbar = $('.module-physicians-search');
            var listing_results = $('.physicians-page-content');
            var filters_modal = $('.physicians-filters-modal');
            var get_data = $.get(updated_uri);
            get_data.done(function(data) {
                listing_results.html($($.parseHTML( data )).find(".physicians-page-content").html());
                searchbar.html($($.parseHTML( data )).find(".module-physicians-search").html());
                filters_modal.html($($.parseHTML( data )).find(".physicians-filters-modal").html());
                window.history.pushState("", "", updated_uri);
                // recall js functions after ajax post to reinitialize
                physicianResultsHandlers(e);
                physicianFilters(e);
                initializeSelectSingle(e);
                initializeSelectMultiple();
                backToTop(e);
                listingMoreCheck(e);
            });
        }
        else {
            const listing_uri = updateQueryStringParameter(updated_uri, 'listing', 1);
            var loader = $('.physicians-results-loader .module-loader');
            var listing_results = $('.page-content #results');
            listing_results.css({'opacity': '0.3', 'pointer-events': 'none'});
            loader.show();
            var get_data = $.get(listing_uri);
            get_data.done(function(data) {
                listing_results.css({'opacity': '1', 'pointer-events': 'auto'}).html($($.parseHTML( data )).find(".page-content #results").html());
                loader.hide();
                window.history.pushState("", "", listing_uri);
                // recall js functions after ajax post to reinitialize
                physicianResultsHandlers(e);
                initializeSelectSingle(e);
                backToTop(e);
                listingMoreCheck(e);
            });
        }
    }

    function handleFilterModalResize() {
        var windowWidth = $(window).width();
        if(windowWidth > 960 ) {
            $('body').removeClass('modal-body');
            $('.physicians-filters-modal').hide();
        }
    }

    function changePhysicianSearchPlaceholder() {
        var windowWidth = $(window).width();

        if(windowWidth < 430 ) {
            $('.physicians-searchbar input').attr('placeholder','Search physicians...');
        }
        else {
             $('.physicians-searchbar input').attr('placeholder','Enter a specialty, name, or location to view results...');
        }
    }

    if ($('.physicians-searchbar').length > 0) {
        // initiate first
        changePhysicianSearchPlaceholder();

        // resize
        $(window).resize( changePhysicianSearchPlaceholder );
    }

    if ($('.physicians-filters-modal').length > 0) {

        // resize
        $(window).resize( handleFilterModalResize );
    }

    var listingMoreCheck = function (e) {
        if ($('.listing-more').length > 0) {
            var maxPage = parseInt($('.listing-more').data('pagecount'));
            var page = 1;
            var miniLoader = $('.module-mini-loader');
            $('.listing-more').on('click', function(e) {
                $(this).find('a').hide();
                miniLoader.show();
                e.preventDefault();
                if (page < maxPage) {
                    page = page + 1;
                    $('.listing-more').before(
                        $('<div class="modules" id="page-'+page+'"></div>').load(window.location.href + '&page='+page+' #physicians-listing .module-physicians-listing', function() {
                            if (page === maxPage) {
                                $('.listing-more').hide();
                            } else {
                                miniLoader.hide();
                                $('.listing-more').find('a').show();
                            };
                        })
                    );
                }
                else if (page === maxPage) {
                    $('.listing-more').hide();
                }
            })
            if (page == maxPage) {
                $('.listing-more').hide();
            }
        }
    };

    listingMoreCheck();

    var backToTop = function (e) {
        $('.js-back-top').on('click', function(e) {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
        });
    }

    backToTop();

    $('.physician-back').on('click', function(e) {
        e.preventDefault();
        var a = document.createElement('a');
        a.href = document.referrer;
        // Note: a.pathname does not start with a "/" on IE
        var physicianListingsPaths = ['/find-physician/', 'find-physician/', '/search/', 'search/'];
        if (history.length > 1 && physicianListingsPaths.indexOf(a.pathname) > -1) {
            history.back();
        }
        else {
            window.location = "/find-physician/";
        }
        a='';
    });

    // ////////////////////////////////////// END PHYSICIAN FILTER MODAL

    // ////////////////////////////////////// START SELECT2

    var initializeSelectMultiple = function() {
        // Select 2
        $('.select2-filters').select2({
            minimumResultsForSearch: 10,
            multiple: true,
            allowClear: false,
            width: 'style',
            closeOnSelect: true,
            placeholder: 'Filter by...',
        });

        $('.js-select2-city').select2({
            placeholder: 'Filter by city...',
        });
        $('.js-select2-facility').select2({
            placeholder: 'Filter by clinic/facility...',
        });
        $('.js-select2-specialty').select2({
            placeholder: 'Filter by specialty...',
        });
        $('.js-select2-interest').select2({
            placeholder: 'Filter by interest...',
        });

        // Make selects absorb aria-label and aria-labelledby attributes.
        const $labelledSelects = $('.select2-hidden-accessible[aria-label]');
        $labelledSelects.each(function(index, select) {
            var $select = $(select);
            var label = $select.attr('aria-label');
            var $input = $select.siblings('.select2-container').find('input');
            $input.attr('aria-label', label);
        });

        const $labelledBySelects = $('.select2-hidden-accessible[aria-labelledby]');
        $labelledBySelects.each(function(index, select) {
            var $select = $(select);
            var labelledBy = $select.attr('aria-labelledby');
            var $input = $select.siblings('.select2-container').find('input');
            $input.attr('aria-labelledby', labelledBy);
        });
    };

    if ($('.select2-filters').length > 0) {
        initializeSelectMultiple();
    }

    // ////////////////////////////////////// END SELECT2

    // ////////////////////////////////////// START GLOBAL ALERT BANNER
    $('.global-alert .js-close-alert').click(function(e) {
        // Don't show this again
        $.ajax({
            url: '/alert-cookie/',
        });

        // Animate Out
        $('body').removeClass('nav-has-alert');
        $('.js-site-header').removeClass('has-alert');

        const $globalAlert = $(this).closest('.global-alert');
        if ($globalAlert.hasClass('is-visible')) {
            $globalAlert.removeClass('is-visible')
        } else {
            $globalAlert.fadeToggle(250);
        }
    });
    // ////////////////////////////////////// END GLOBAL ALERT BANNER


    // ////////////////////////////////////// START FILTERS

    // Filters
    $('.filter-trigger').click(function(e) {
        e.preventDefault();

        var self = this;
        var filterId = '#' + $(self).attr('aria-controls');
        var $menuitem = $(self);
        var $menu = $(filterId);

        if ($menuitem.hasClass('active')) {
            $menuitem.removeClass('active');
            $('.sub-filters.active').slideUp(250, function() {
                $menu.removeClass('active');
                $menuitem.toggleBoolAttr('aria-expanded');
            });
        } else if ($('.filter-trigger').not(self).hasClass('active')) {
            $('.filter-trigger.active').removeClass('active');
            $menuitem.addClass('active');
            $('.sub-filters.active').slideUp(250, function() {
                $(this).removeClass('active');
                $menu.slideDown(250, function() {
                    $menu.addClass('active');
                    $menuitem.toggleBoolAttr('aria-expanded');
                });
            });
        } else {
            $menuitem.addClass('active');
            $menuitem.toggleBoolAttr('aria-expanded');
            $menu.slideDown(250, function() {
                $menu.addClass('active');
            });
        }
    });


    // ////////////////////////////////////// START FILTERING

    // Returns params from URL as an object {param1:[value1, value2],param2:[value1],...}
    function getUrlParams() {
        var query_string = {};
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if (query_string[pair[0]]) {
                query_string[pair[0]].push(pair[1]);
            }
            else {
                query_string[pair[0]] = [];
                query_string[pair[0]].push(pair[1]);
            }
        }
        return query_string;
    }

    // Get query_string
    var query_string = getUrlParams();

    $('.show-span').click( function () {
        // service-search does not have a reliable id
        var $span = $(this);
        if ($span.hasClass('service-search') || $span.hasClass('show-span--search')) {
            delete query_string.search;
        }
        else {
            var span_id = $span.attr('data-id');
            var hash = $span.attr('data-hash');

            if (!span_id) {
                span_id = $span.attr('id');
            }

            for (var key in query_string) {
                var index = query_string[key].indexOf(span_id);
                if (index > -1) {
                    query_string[key].splice(index, 1);
                    if (query_string[key] == []) {
                        delete query_string[key];
                    }
                    break;
                }
            }
        }
        delete query_string[""];
        query_string.page = 1;
        var shallowEncoded = $.param( query_string, true );
        var newUrl = window.location.pathname + '?' + decodeURIComponent(shallowEncoded);
        if (hash) {
            newUrl += `#${hash}`;
        }
        window.location = newUrl;
    });

    $('.sub-filters .filter-btn, .filter-options .filter-btn').click(function(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        var $button = $(this);
        var filter = $button.attr('data-filter-name');
        var button_id = $button.attr('data-id');
        var hash = $button.attr('data-hash');

        if (!button_id) {
            button_id = $button.attr('id');
        }

        if (!$button.hasClass('active')) {
            // Add filter key if not in query_string
            if (! query_string[filter]) {
                query_string[filter] = [];
            }
            // Add filter value to query_string if not present
            if (query_string[filter].indexOf(button_id) == -1) {
                query_string[filter].push(button_id);
            }
        } else {
            for (let key in query_string) {
                var index = query_string[key].indexOf(button_id);
                if (index > -1) {
                    query_string[key].splice(index, 1);
                    if (query_string[key] == []) {
                        delete query_string[key];
                    }
                    break;
                }
            }
        }
        delete query_string[""];
        query_string.page = 1;
        if (query_string) {
            // Allows for several of same param
            var shallowEncoded = $.param( query_string, true );
            var newUrl = window.location.pathname + '?' + decodeURIComponent(shallowEncoded);
            if (hash) {
                newUrl += `#${hash}`;
            }
            window.location = newUrl;
        }
    });

    // ////////////////////////////////////// END FILTERING

    // ////////////////////////////////////// START BLOG

    // Blog Filters
    $('.show-subfilters').click(function(e) {
        $(this).siblings('.blog-subfilters').slideToggle(250);
    });

    // ////////////////////////////////////// END BLOG

    // ////////////////////////////////////// START ACCESS LISTING

    if ($('#access-primary-listing').length > 0) {
        var primary_list = $('#access-primary-listing').first();
        $.ajax({
            url: '/access-listing-items/primary/?city=' + primary_list.attr('data-city'),
        }).done(function(data) {
            if (data.trim().length > 0) {
                primary_list.find('.access-listing').first().prepend(data);
                primary_list.removeClass('is-loading');
            } else {
                primary_list.addClass('no-results');
                primary_list.removeClass('is-loading');
            };
            
        });
    }
    if ($('#access-walkin-listing').length > 0) {
        var walkin_list = $('#access-walkin-listing').first();
        $.ajax({
            url: '/access-listing-items/walkin/?city=' + walkin_list.attr('data-city'),
        }).done(function(data) {
            if (data.trim().length > 0) {
                walkin_list.find('.access-listing').first().prepend(data);
                walkin_list.removeClass('is-loading');
            } else {
                walkin_list.addClass('no-results');
                walkin_list.removeClass('is-loading');
            };
            
        });
    }
    if ($('#access-urgent-listing').length > 0) {
        var urgent_list = $('#access-urgent-listing').first();
        $.ajax({
            url: '/access-listing-items/urgent/?city=' + urgent_list.attr('data-city'),
        }).done(function(data) {
            if (data.trim().length > 0) {
                urgent_list.find('.access-listing').first().prepend(data);
                urgent_list.removeClass('is-loading');
            } else {
                urgent_list.addClass('no-results');
                urgent_list.removeClass('is-loading');
            };
            
        });
    }

    // ////////////////////////////////////// END ACCESS LISTING

    // ////////////////////////////////////// START DROPDOWN SELECTS

    var initializeSelectSingle = function() {
        // Reinitalize sort select
        if ($('.select2-single').length) {
            const $singleSelect = $('.select2-single').select2({
                minimumResultsForSearch: Infinity,
                allowClear: false,
                width: 'style',
            });
            if ($singleSelect.data('select2')) {
                var singleSelectAriaLabel = $singleSelect.data('select2')['$element'][0]['ariaLabel'];
                var $singleSelectContainer = $singleSelect.data('select2')['$container'][0];
                $($singleSelectContainer).attr('aria-label', singleSelectAriaLabel)
            }

            $('select.submit-on-select').on('change', function(e) {
                $(this).closest('form').submit();
            });

            // Add onchange function for sort select
            $('.physicians-sort select').on('change', function(e) {
                e.preventDefault();
                var selection = $(this).val();

                const updated_uri = updateQueryStringParameter(window.location.href, 'sort', selection);
                var loader = $('.physicians-results-loader .module-loader');
                var listing_results = $('.page-content #results');
                listing_results.css({'opacity': '0.3', 'pointer-events': 'none'});
                loader.show();
                var get_data = $.get(updated_uri);
                get_data.done(function(data) {
                    listing_results.css({'opacity': '1', 'pointer-events': 'auto'}).html($($.parseHTML( data )).find(".page-content #results").html());
                    loader.hide();
                    window.history.pushState("", "", updated_uri);
                    // recall js functions after ajax post to reinitialize
                    physicianResultsHandlers(e);
                    initializeSelectSingle(e);
                    backToTop(e);
                    listingMoreCheck(e);
                });
            });
        }
    };

    initializeSelectSingle();

    // ////////////////////////////////////// END DROPDOWN SELECTS

    // ////////////////////////////////////// START SEARCH DROPDOWN
    if ($('.js-filter-services select').length) {
        var $filterBar = $('.js-filter-services select');
        $filterBar.select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: $('.module-search-bar'),
            width: '100%'
        });
        var filterBarAriaLabel = $filterBar.data('select2')['$element'][0]['ariaLabel'];
        var $filterBarContainer = $filterBar.data('select2')['$container'][0];
        $($filterBarContainer).attr('aria-label', filterBarAriaLabel);

        $filterBar.on('select2:select', function(e) {
            var selectedEl = $filterBar.select2('data')[0].element;
            var url = $(selectedEl).data('url');
            window.location = url;
        });
    }

    // ////////////////////////////////////// END SEARCH DROPDOWN


    // ////////////////////////////////////// START IMAGE HEADER SELECT
    if ($('.image-header-select .filterbar select').length) {
        var $headerSelect = $('.image-header-select .filterbar select');
        $headerSelect.select2({
            dropdownParent: $('.image-header-select'),
            width: '100%'
        });
        var headerSelectAriaLabel = $headerSelect.data('select2')['$element'][0]['ariaLabel'];
        var $headerSelectContainer = $headerSelect.data('select2')['$container'][0];
        $($headerSelectContainer).attr('aria-label', headerSelectAriaLabel);

        $headerSelect.on('select2:select', function(e) {
            var selectedEl = $headerSelect.select2('data')[0].element;
            var url = $(selectedEl).data('url');
            window.location = url;
        });
    }

    // ////////////////////////////////////// END IMAGE HEADER SELECT


    // ////////////////////////////////////// START LOCATIONS

    // Locations
    $('.module-quick-switcher select').change(function(e) {
        e.preventDefault();
        var $select = $(this),
            locId = $select.val(),
            value;

        value = $select.find('option[value="' + locId + '"]').text()

        $('.switcher-item.is-shown').removeClass('is-shown');
        $('.switcher-item#'+locId).addClass('is-shown');
    });

    // ////////////////////////////////////// END LOCATIONS

    // ////////////////////////////////////// START EVENTS

    //  Event catogories drop-down
    $('.eventCatogories').on('click', function(e) {
        $(this).parent('.categories').toggleClass('hidden');
        if ($(this).html() == 'navigatedown'){
            $(this).html('navigateup')
        }
        else {
            $(this).html('navigatedown');
        }
    });

    // ////////////////////////////////////// END EVENTS

    // ////////////////////////////////////// START READ MORE

    var seemore = false;

    // See More
    $('.js-toggle-info').click(function(e) {
        e.preventDefault();

        var $expand = $(this).parent('.expandable');

        if (seemore == false) {
            $expand.addClass('expanded');
            $(this).text('Hide this');
            seemore = true;
        } else if (seemore == true) {
            $expand.removeClass('expanded');
            $(this).text('Continue Reading...');
            seemore = false;
        }
    });

    // ////////////////////////////////////// END READ MORE

    // ////////////////////////////////////// START ACCORDION

    // Accordion

    $('.module-accordion').each(function(i, el) {
        var $expander = $(el).find('.expand-all'),
            on_text = $expander.text(),
            off_text = $expander.attr('data-alt');
        $expander = null;

        $(el).on('click', '.expand', function() {
            var open = $(this).hasClass('open');
            var $item = $(this).parents('.ac-item');
            $(this).toggleClass('open');
            $item.find('.expand-wrapper').toggleClass('open');


            if ($(el).find('.expand').index(this) == 0) {
                $(el).find('.expand-all').text(open ? on_text : off_text);
            }

            $item.find('.ac-wrap')[open ? 'slideUp' : 'slideDown'](200, function(){
                $(this).children().toggleClass('visible');
            });
        });

        $(el).on('click', '.expand-all', function() {
            var $btns = $(el).find('.expand'),
                open = $btns.first().hasClass('open');

            $btns.toggleClass('open', !open);
            $(el).find('.expand-all').text(open ? on_text : off_text);

            $(el).find('.ac-wrap')[open ? 'slideUp' : 'slideDown'](200, function(){
                $(this).children().toggleClass('visible', !open);
            });
        });
    });

    // ////////////////////////////////////// END ACCORDION


    // ////////////////////////////////////// START ACCESS PAGE EXPAND CALLOUTS

    $('#access-expand-trigger').on('click', function() {
        $('.access-icon-callout-button').each( function(i, el) {
            $(el).toggleClass('is-hidden');
        })
        const expandedWrapper = $(this).parent().prev('.icon-callout-expanded-wrapper');
        expandedWrapper.toggleClass('is-open');
        if (expandedWrapper.hasClass('is-open')) {
            expandedWrapper.slideDown(250);
            $(this).attr('aria-expanded', 'true');
            $(this).find('.is-open').toggleClass('is-hidden');
            $(this).find('.is-closed').toggleClass('is-hidden');
        } else {
            expandedWrapper.slideUp(250);
            $(this).attr('aria-expanded', 'false');
            $(this).find('.is-closed').toggleClass('is-hidden');
            $(this).find('.is-open').toggleClass('is-hidden');
        }
    });

    // ////////////////////////////////////// END ACCESS PAGE EXPAND CALLOUTS


    $('option').on('click', function(){
        $(this).closest('div').find('span').text($(this).text());
    });

    // ////////////////////////////////////// START IFRAME

    $('.page-iframe').find('iframe').on('load', function(e) {
        e.preventDefault();

        $('.page-iframe').addClass('is-loaded');
    });

    // Allow resizing of iframes that use the iframe resizer library:
    // http://davidjbradshaw.github.io/iframe-resizer/
    //
    // To use, add the #resizing-iframe class to your iframe
    const options = {
        heightCalculationMethod: 'lowestElement',
        inPageLinks: true,
        initCallback: (iFrame) => {
            iFrame.iFrameResizer.moveToAnchor('results');
        },
    };
    iframeResize(options, 'iframe.resizing-iframe');

    // ////////////////////////////////////// END IFRAME

    // ////////////////////////////////////// START ACCESSIBLE MENUBARS

    var menuSelector = '[role="menu"]';
    var menuitemSelector = '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]';

    $(menuitemSelector).keydown(function(e) {
        var $menuitem = $(e.target);
        var $li = $menuitem.closest('li');
        var $lis = $menuitem.closest('ul').children('li');
        var menuId = $menuitem.attr('aria-controls');
        var menuitemId = $menuitem.attr('data-menuitem-id');
        var $nextLi;
        var $prevLi;
        var $nextFocus;
        var $menu;
        var hasMenu;

        var resetFocus = function($newFocus) {
            var currentFocus = document.activeElement;
            currentFocus.setAttribute('tabindex', '-1');
            $newFocus.focus();
            $newFocus.attr('tabindex', '0');
        };

        $menu = $menuitem.siblings(menuSelector);
        if (menuId && !$menu.length) {
            // This case is for menus that are not direct siblings of the
            // menuitem.
            $menu = $(document).find('#' + menuId);
        }
        hasMenu = !!$menu.length;

        switch (e.keyCode) {
        case VK_DOWN:
        case VK_SPACE:
        case VK_ENTER:
            if (hasMenu) {
                // Open menu if there is one and go to first item.
                if ($menuitem.hasClass('filter-trigger')) {
                    $menuitem[0].click();
                } else {
                    $menuitem.toggleBoolAttr('aria-expanded');
                    $menu.slideDown(250);
                }
                $nextFocus = $menu.find(menuitemSelector).first();
                resetFocus($nextFocus);
            } else {
                if (e.keyCode == VK_SPACE || e.keyCode == VK_ENTER) {
                    // For space and enter, follow the link.
                    $menuitem[0].click();
                } else {
                    // Switch to next menuitem if we're inside a menu with no other children.
                    $menu = $menuitem.closest(menuSelector);
                    $nextLi = $li.next('li:has(' + menuitemSelector + ')');
                    if ($nextLi.length) {
                        $nextFocus = $nextLi.find(menuitemSelector).first();
                        resetFocus($nextFocus);
                    } else {
                        $nextFocus = $lis.first().find(menuitemSelector).first();
                        resetFocus($nextFocus);
                    }
                }
            }
            e.preventDefault();
            break;
        case VK_UP:
            if (hasMenu) {
                // Open menu if there is one and go to last item.
                if ($menuitem.hasClass('filter-trigger')) {
                    $menuitem[0].click();
                } else {
                    $menuitem.toggleBoolAttr('aria-expanded');
                    $menu.slideDown(250);
                }
                $nextFocus = $menu.find(menuitemSelector).last();
                resetFocus($nextFocus);
            } else {
                // Switch to prev menuitem if we're inside a menu with no other children.
                $menu = $menuitem.closest(menuSelector);
                $prevLi = $li.prev('li:has(' + menuitemSelector + ')');
                if ($prevLi.length) {
                    $nextFocus = $prevLi.find(menuitemSelector).first();
                    resetFocus($nextFocus);
                } else {
                    $nextFocus = $lis.last().find(menuitemSelector).first();
                    resetFocus($nextFocus);
                }
            }
            e.preventDefault();
            break;
        case VK_RIGHT:
            $nextLi = $li.next('li:has(' + menuitemSelector + ')');
            if ($nextLi.length) {
                $nextFocus = $nextLi.find(menuitemSelector).first();
                resetFocus($nextFocus);
            } else {
                $nextFocus = $lis.first().find(menuitemSelector).first();
                resetFocus($nextFocus);
            }
            e.preventDefault();
            break;
        case VK_LEFT:
            $prevLi = $li.prev('li:has(' + menuitemSelector + ')');
            if ($prevLi.length) {
                $nextFocus = $prevLi.find(menuitemSelector).first();
                resetFocus($nextFocus);
            } else {
                $nextFocus = $lis.last().find(menuitemSelector).first();
                resetFocus($nextFocus);
            }
            e.preventDefault();
            break;
        case VK_HOME:
            $nextFocus = $lis.first().find(menuitemSelector).first();
            resetFocus($nextFocus);
            e.preventDefault();
            break;
        case VK_END:
            $nextFocus = $lis.last().find(menuitemSelector).first();
            resetFocus($nextFocus);
            e.preventDefault();
            break;
        case VK_ESC:
            if (!hasMenu) {
                $nextFocus = $menuitem.closest('ul').closest('li').find(menuitemSelector).first();
                if (!$nextFocus.length) {
                    // This case is for menus that are not direct siblings of
                    // the menuitem.
                    $nextFocus = $(document).find('#' + menuitemId).first();
                }

                if ($nextFocus.hasClass('filter-trigger')) {
                    // If we're not in the sidebar-style (Blog) filter...
                    $nextFocus[0].click();
                } else {
                    // This type of filter is a link, so we don't want to
                    // click it. We just want to expand for now.
                    $menu = $menuitem.closest(menuSelector);
                    $nextFocus.toggleBoolAttr('aria-expanded');
                    $menu.slideUp(250);
                }

                resetFocus($nextFocus);
            }
            e.preventDefault();
            break;
        }

    });

    // ////////////////////////////////////// END ACCESSIBLE MENUBARS

    // ////////////////////////////////////// START ACCESSIBLE HERO CALLOUTS

    $('.js-hero-callout-link').focus(function(e) {
        $(e.currentTarget).closest('.js-hero-callout').addClass('active')
    });

    $('.js-hero-callout-link').blur(function(e) {
        $(e.currentTarget).closest('.js-hero-callout').removeClass('active')
    });

    // ////////////////////////////////////// END ACCESSIBLE HERO CALLOUTS

    // ////////////////////////////////////// START SMOOTH HASH SCROLLING
    var hashBlacklist = [
        '#mobile-menu',
        '#mobile-close',
        '#mobile-menu-toggle',
        // '#nav-item-1',
        '#nav-item-2',
        '#nav-item-3',
        '#nav-item-4',
        '#nav-item-5',
    ];

    $("a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior.
        // We also want to make sure that it isn't a hash inside of an external URL.
        // Finally, we want to make sure it's not related to our no-JS navigation hashes.
        var href = this.getAttribute('href');
        if (this.hash !== ""
               && href[0] == '#'
               && !hashBlacklist.includes(this.hash)) {
             // Prevent default anchor click behavior
             event.preventDefault();

             // Store hash
             var hash = this.hash;
             var $hash = $(hash);

             // Using jQuery's animate() method to add smooth page scroll
             // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
             $('html, body').animate({
                 scrollTop: $hash.offset().top
             }, 800, function(){
                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
             });
         }
    });
    // ////////////////////////////////////// END SMOOTH HASH SCROLLING

    // ////////////////////////////////////// HERO SLIDER

    var $heroSliderModule = $('.module-hero-slider');
    var sliderDelay = $heroSliderModule.data('delay');
    var $heroSlider = $heroSliderModule.find('.slick-wrapper');

    $heroSlider.slick({
        accessibility: true,
        autoplay: sliderDelay,
        autoplaySpeed: sliderDelay ? (parseFloat(sliderDelay) * 1000) : false,
        dots: true,
        arrows: false,
        appendDots: '.module-hero-slider-pagination .pagination',
    });

    if (sliderDelay) {
        $('.module-hero-slider-pagination .pause-play').clickToggle(function() {
            var $pausePlay = $(this);
            $pausePlay.find('i').html('play');
            $heroSlider.slick('slickPause');
        }, function() {
            var $pausePlay = $(this);
            $pausePlay.find('i').html('pause');
            $heroSlider.slick('slickPlay');
        });
    }

    // Enable the point on the Homepage
    function setRightThingPoint(event, slick, currentSlide, nextSlide) {
        if (!$heroSliderModule.length) {
            return;
        }

        let $rightThing;
        let heroSliderModule = $heroSliderModule[0];

        if (nextSlide || nextSlide === 0) {
            const nextSlideSelector = `[data-slick-index="${nextSlide}"] .right-thing-point b`;
            $rightThing = $heroSlider.find(nextSlideSelector);
        } else {
            $rightThing = $heroSliderModule.find('.slick-current .right-thing-point b');
        }

        const $point =  $heroSliderModule.find('.hero-slider__point');
        if ($rightThing.length) {
            const fontHeight = $rightThing.css('font-size').replace('px', '');
            const rightThingOffset = $rightThing.offset().top + fontHeight/2 - $heroSliderModule.offset().top;
            heroSliderModule.style.setProperty('--point-middle-offset', `${rightThingOffset}px`);
            $point.css('opacity', '100%');
        } else {
            heroSliderModule.style.setProperty('--point-middle-offset', '0px');
            $point.css('opacity', '0');
        }
    }
    setRightThingPoint();
    $heroSlider.on('beforeChange', setRightThingPoint);
    $(window).resize(setRightThingPoint);

    // ////////////////////////////////////// END HERO SLIDER

    // ////////////////////////////////////// START CARD SLIDER

    var $cardSlider = $('.js-card-slider .js-card-slides');

    $cardSlider.each(function(i, el) {
        const $el = $(el);
        const $sliderParent = $el.closest('.js-card-slider');
        $(el).slick({
            accessibility: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: $sliderParent.find('.slick-prev'),
            nextArrow: $sliderParent.find('.slick-next'),
            responsive: [
                {
                    breakpoint: 1224,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '90px',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                        infinite: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '0',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                        infinite: false,
                        dots: true,
                    }
                },
            ]
        });
    });

    // ////////////////////////////////////// END CARD SLIDER

    // ////////////////////////////////////// START SLIDER MODULE

    $('.slick-full').each(function(i, el) {
        const $el = $(el);
        const $sliderParent = $el.closest('.slick-container');
        $(el).slick({
            accessibility: true,
            prevArrow: $sliderParent.find('.slick-prev'),
            nextArrow: $sliderParent.find('.slick-next'),
            responsive: [
                {
                    breakpoint: 1224,
                    settings: {
                        arrows: false,
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                        infinite: false,
                    }
                },
            ]
        });
    });

    $('.slick-half').each(function(i, el) {
        const $el = $(el);
        const $sliderParent = $el.closest('.slick-container');
        $(el).slick({
            accessibility: true,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: $sliderParent.find('.slick-prev'),
            nextArrow: $sliderParent.find('.slick-next'),
            responsive: [
                {
                    breakpoint: 1224,
                    settings: {
                        arrows: false,
                        dots: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        touchMove: true,
                        infinite: false,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false,
                        accessibility: true,
                        centerMode: true,
                        centerPadding: '50px',
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        touchMove: true,
                        infinite: false,
                    }
                },
            ],
        });
    });

    // ////////////////////////////////////// END SLIDER MODULE

    // ////////////////////////////////////// START ER EXPRESS
    function initializeERExpressListeners() {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        eventer(messageEvent, function (e) {
            if (e.origin.indexOf("erexpress.com") > -1) {
                //console.log('received message!:  ', e);
                var messageArray = e.data.split('|');

                if (messageArray[0] == 'CheckInSubmitted' && messageArray[1] == 'true') {
                    // Triggered by  a check-in event
                }
                else {
                    //Call to CSS for height adjustment
                    $('#' + messageArray[0]).css({ 'height': (parseInt(messageArray[1]) + 20) + 'px' });
                }
            }
        }, false);
    }
    function postMessageToIframe(iframeId, messsage) {
        var win = $('#' + iframeId)[0].contentWindow;
        win.postMessage(message, "*");
    }
    const erExpressIframeExists = $('#ERExpressiframe');
    if (erExpressIframeExists) {
        initializeERExpressListeners();
    }
    // ////////////////////////////////////// END ER EXPRESS

    /**
     * Uses the Google Maps javascript api to create a cluster map.
     * The data for the markers and the InfoWindows is pulled from the
     * DOM content in the $wrapper's .pin child elements
     * @param $wrapper jQuery element containing a .map element and .pin elements
     */
    function clusterMap($wrapper) {
        const $pins = $wrapper.find('.map-data .pin');

        const $map = $wrapper.find('.map');

        const mapPins = [];

        $pins.each(function() {
            const $pin = $(this);

            // Pulls the long and lat info from data attributes on the .pin elements
            const lng = parseFloat($pin.data('longitude'));
            const lat = parseFloat($pin.data('latitude'));

            const count = String($pin.find('.items .item').length);
            const content = $pin.html();

            mapPins.push({
                lng,
                lat,
                content,
                count
            })
        });

        window.addEventListener('gmapsLoaded', () => {
            // Styling configuration pulled from https://snazzymaps.com/style/151/ultra-light-with-labels
            const styledMap = new google.maps.StyledMapType([
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]);

            const map = new google.maps.Map($map[0], {
                zoom: 3,
                center: {lat: 37.215519, lng: -93.292358}
            });

            map.mapTypes.set('styled_map', styledMap);
            map.setMapTypeId('styled_map');

            // All of the markers coordinates get added to the bounds object
            const bounds = new google.maps.LatLngBounds();

            const markers = mapPins.map(pin => {

                // The .pin elements innerHTML becomes the content for the InfoWindow
                const infoWindow = new google.maps.InfoWindow({
                   content: pin.content,
                });

                const marker = new google.maps.Marker({
                    position: {lat: pin.lat, lng: pin.lng},
                    label: pin.count
                });

                marker.addListener('click', () => {
                   infoWindow.open(map, marker);
                });

                // Closes the InfoWindow when clicking anywhere on the map itself
                map.addListener('click', () => {
                   infoWindow.close(map, marker);
                });

                bounds.extend(marker.position);

                return marker;
            });

            // We use that bounds object to center the map around all of the markers
            map.fitBounds(bounds);

            const markerCluster = new MarkerClusterer(map, markers,
            {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
        });
    }

    const $clusterMapWrapper = $('.js-cluster-map');

    // Only initialize the clusterMap if we can find the wrapper elements on the page.
    if($clusterMapWrapper.length) {
        clusterMap($clusterMapWrapper)
    }

    function locationMap($wrapper) {
        const $map = $wrapper.find('.map');

        const lng = parseFloat($map.data('lng'));
        const lat = parseFloat($map.data('lat'));

        const coords = { lng, lat };

        window.addEventListener('gmapsLoaded', () => {
            const map = new google.maps.Map($map[0], {
                zoom: 14,
                scrollwheel: false,
                center: coords,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            const marker = new google.maps.Marker({
                position: coords,
                map,
            });
        });
    }

    const $locationMapWrapper = $('.js-location-map');

    if($locationMapWrapper.length) {
        locationMap($locationMapWrapper);
    }

    // After all events are bound we make sure to fire off the map event
    documentReady = true;
    fireMapsEvent();

    // During the full page module conversion we came across a bug where if a stretch module
    // is the last module in a full width section and there is a two thirds section just after it,
    // the stretch module will go beneath the two thirds section. The bug is caused by the fact that
    // we want stretch modules to fit up against the footer area without any whitespace. The fix is this
    // bit of JS that checks if a stretch module is the last in a full width section and that it's followed
    // by another full width section or two thirds section
    function fixFinalStretchModuleVerticalSpacing() {
        const $firstFullWidth =  $('.page-content-full').first();
        const $firstFullWidthSibling = $firstFullWidth.next();

        if (
            !$firstFullWidthSibling.hasClass('page-content-full') &&
            !$firstFullWidthSibling.hasClass('content-sidebar-container')
        ) {
            return;
        }

        const $lastFirstFullWidthModule = $firstFullWidth.find('.modules').children().last();

        if (!$lastFirstFullWidthModule.hasClass('module-stretch')) {
            return;
        }

        $lastFirstFullWidthModule.addClass('mb-1');
    }
    fixFinalStretchModuleVerticalSpacing();
});

// Animates the graphs in insights-module
if ($('.module-insights')) {
      const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('animate')
          observer.unobserve(entry.target)
        }
      }, {
        threshold: 1,
        rootMargin: '20%'
      })
    });
    document.querySelectorAll('.percentage-stat').forEach(insight => observer.observe(insight))
}


/************* STICKY NAV DISPLAY ON SCROLL  ***************/


if ($('.mobile-sticky-nav')) {
    const $stickyNav = $('.mobile-sticky-nav');
    $(window).on('scroll', function() {
        var height = $(window).scrollTop();
        if ($(window).width() <= 960) {
            if (height > 30) {
                $stickyNav.addClass("slidedown");
            } else {
                $stickyNav.removeClass("slidedown");
            }
        }
    });
}
